// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto } from './IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto';
import {
    IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto';
import type { ICardStatusMultiEmployersSummaryRecordDto } from './ICardStatusMultiEmployersSummaryRecordDto';
import {
    ICardStatusMultiEmployersSummaryRecordDtoFromJSON,
    ICardStatusMultiEmployersSummaryRecordDtoFromJSONTyped,
    ICardStatusMultiEmployersSummaryRecordDtoToJSON,
    ICardStatusMultiEmployersSummaryRecordDtoToJSONTyped,
} from './ICardStatusMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<ICardStatusMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto
     */
    employer_records?: Array<ICardStatusMultiEmployersSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(ICardStatusMultiEmployersSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoCardStatusMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(ICardStatusMultiEmployersSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoCardStatusMultiEmployersSummaryRecordDtoToJSON)),
    };
}

